export default __webpack_public_path__ + "static/media/new-mobile-2.427d0500.png";